import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ExpenseReimbursementItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'expense-reimbursement-item'
  }

}